import styled from 'styled-components'

export default styled.div`
  > .list {
    display: flex;
    width: 100%;
    flex-direction: column;
    border-bottom: 1px solid #ffd5b2;
  }
  .title {
    cursor: pointer;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
    padding: 12px 0;
    .number {
      width: 33px;
      height: 33px;
      background: #ffe3cc;
      color: #ff8e00;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
    }
    > .right {
      padding-left: 15px;
      padding-right: 5px;
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
  }
  .content-parent {
    visibility: hidden;
    height: 0;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s linear, height 0s linear;
    &.active {
      visibility: visible;
      height: 100%;
      opacity: 1;
      transition: visibility 0s, opacity 0.5s linear, height 0.7s linear;
    }
    > .thanks {
      text-align: center;
      box-sizing: border-box;
      padding: 40px 30px 10px 20px;
    }
    > .fvb-wrap {
      text-align: center;
      box-sizing: border-box;
      padding: 10px;
      > p {
        font-family: Roboto;
      }
      > .fvb-flx {
        display: flex;
        justify-content: space-evenly;
        > .fvb-st {
          background: none;
          border: 1px solid #ff624b;
          box-sizing: border-box;
          border-radius: 5px;
          width: 50%;
          margin: 0px 7px;
          padding: 10px;
          color: #ff624b;
          font-family: Open Sans;
          text-decoration: none;
          font-size: 12px;
        }
      }
    }
    .dl-faq {
      .dtl-ttl-wrp {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 24px;
        font-size: 16px;
        font-weight: bold;
        color: #555555;
        position: relative;
        > span {
          font-weight: bold;
        }
      }
      .frm-fddbck {
        padding: 20px 24px;
        box-sizing: border-box;
        > textarea {
          width: 100%;
          background: #eeeeee;
          border-radius: 5px;
          border: none;
          resize: none;
          outline: none;
          box-sizing: border-box;
          padding: 16px;
          font-family: Open Sans;
        }
        > input {
          width: 100%;
          background: #eeeeee;
          border-radius: 5px;
          border: none;
          resize: none;
          outline: none;
          box-sizing: border-box;
          padding: 16px;
          margin-bottom: 16px;
          font-family: Open Sans;
        }
      }
      .btns-wrp {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 24px;
        > .snd-btn {
          border-radius: 5px;
          font-family: Open Sans;
          width: 100%;
          box-sizing: border-box;
          padding: 12px 0px;
          background: linear-gradient(159.78deg, #ff7f5f 37.5%, #ff6049 100%);
          color: #ffffff;
          border: none;
          &:disabled {
            background: linear-gradient(0deg, #dddddd, #dddddd);
            color: #888888;
            border: none;
          }
        }
      }
    }
  }
  .content {
    background-color: #fbfbfb;
    width: 100%;
    display: flex;
    flex-direction: column;
    display: flex;
    padding: 24px 24px 24px 50px;

    &-accordion {
      flex-direction: column;
      display: flex;
      width: 100%;
      justify-content: space-between;
      border-bottom: 1px solid #ececec;
      padding: 12px 0;
    }
  }
  .arrow {
    > i {
      border: solid #ff7c12;
      border-width: 0px 2px 2px 0;
      display: inline-block;
      padding: 4px;
      transform: rotate(-135deg);
      transition: transform 0.3s ease-in-out;
      &.up {
        transform: rotate(-135deg);
      }
      &.down {
        transform: rotate(45deg);
      }
    }
  }

  .title-accordion {
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-decoration: none;
    color: #ff7400;
  }
  .content-child {
    display: flex;
    background: #eeeeee;
    width: 100%;
    p {
      font-family: 'Open Sans';
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
    }
    .list-number {
      list-style: number;
    }
    .list-none {
      list-style: none;
    }
    ol {
      padding: 0 40px;
    }
  }

  @media screen and (min-width: 300px) and (max-width: 700px) {
    .content-parent {
      .content {
        padding: 14px 0 24px 0;
        background: transparent;
      }
    }

    .content-child {
      width: calc(100% + 30px);
      position: relative;
      left: -15px;

      ol {
        padding: 0 34px !important;
        margin: 10px 0;
      }
    }
  }
`
